module.exports = __webpack_public_path__ + "img/18-baby.b0d5b6d8.svg";